import type { Person } from '../../../eventsApi/persons/person'
import type { PartnerEntry } from '../entries/partner-entry.entity'
import type { PartnerPerson } from '../persons/partner-person.entity'

export class Partner {
    partnerId: string
    personId: string
    companyId: string
    notes?: string
    pix?: string
    paymentDelay: number
    createdAt: string | Date
    updatedAt: string | Date
    status: number
    comissionPercent: number
    partnersPersons?: PartnerPerson[]
    partnersEntries?: PartnerEntry[]
    person: Person
}
